import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 0.42395H1.09998V50.424H66V0.42395Z" fill="white" />
    <path d="M66 44.686H1.09998V50.686H66V44.686Z" fill="white" />
    <path d="M66 44.424H1.09998V50.424H66V44.424Z" fill="#338AF3" />
    <path d="M66 32.267H1.09998V38.267H66V32.267Z" fill="white" />
    <path d="M66 32.0601H1.09998V38.0601H66V32.0601Z" fill="#338AF3" />
    <path d="M66 18.665H1.09998V24.665H66V18.665Z" fill="#338AF3" />
    <path d="M66 6.30005H1.09998V12.3H66V6.30005Z" fill="#338AF3" />
    <path d="M19.6 6.30005H0V12.3H19.6V6.30005Z" fill="white" />
    <path d="M20.6 0.300049H0.900024V24.3H20.6V0.300049Z" fill="#338AF3" />
    <path d="M20 6.30005H1.09998V12.3H20V6.30005Z" fill="white" />
    <path d="M13.1 0H7.09998V18.5H13.1V0Z" fill="white" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
